import { createTheme } from '@mui/material/styles';

// Define color palette
export const colors = {
  // Primary colors - more muted, less acidic
  primary: {
    // main: '#4CAF50',    // Muted green instead of bright green
    main: '#FF0000',    // RED DEATH
    light: '#81C784',   // Softer light green
    // dark: '#388E3C',    // Deeper dark green
    dark: '#CC0000',    // RED DARKER
    contrastText: '#FFFFFF',
  },
  // Secondary colors - more muted, less acidic
  secondary: {
    main: '#26A69A',    // Teal instead of bright cyan
    light: '#4DB6AC',   // Softer light teal
    dark: '#00897B',    // Deeper dark teal
    contrastText: '#FFFFFF',
  },
  // Background colors - kept dark but slightly warmer
  background: {
    default: '#0F2231',  // Dark blue-green from app background
    paper: '#132F3E',    // Slightly lighter dark blue-green
    card: '#132F3E',     // Same as paper
  },
  // Text colors - slightly warmer
  text: {
    primary: '#FFFFFF',  // White text
    secondary: '#B0BEC5', // Warmer light gray text
    disabled: '#78909C',  // Warmer dark gray text
  },
  // Border colors - more muted
  border: {
    main: '#4CAF50',     // Muted green border
    light: '#81C784',     // Softer light green border
  },
  // Divider color - slightly warmer
  divider: '#1E3A4A',     // Warmer dark blue-green divider
  // Other colors - more muted
  error: {
    main: '#E57373',      // Softer red
  },
  warning: {
    main: '#FFB74D',      // Softer amber
  },
  info: {
    main: '#4FC3F7',      // Softer blue
  },
  success: {
    main: '#4CAF50',      // Muted green
  },
};

// Define spacing
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// Define breakpoints
export const breakpoints = {
  values: {
    xs: 0,
    sm: 375,
    md: 600,
    lg: 960,
    xl: 1280,
  },
};

// Define shadows
export const shadows = {
  card: '0 4px 12px rgba(0, 0, 0, 0.2)',
};

// Create and export the theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: colors.primary,
    secondary: colors.secondary,
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
    error: {
      main: colors.error.main,
    },
    warning: {
      main: colors.warning.main,
    },
    info: {
      main: colors.info.main,
    },
    success: {
      main: colors.success.main,
    },
    divider: colors.divider,
  },
  spacing: (factor: number) => `${factor * 8}px`,
  breakpoints: {
    values: breakpoints.values,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '22px',
      fontWeight: 500,
    },
    h2: {
      fontSize: '28px',
      fontWeight: 500,
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '10px 16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.card,
          borderRadius: '16px',
          boxShadow: shadows.card,
          border: `1px solid ${colors.border.main}`,
        },
      },
    },
  },
});

export default theme;
